<script setup lang="ts">
import { $createParagraphNode, $getSelection, $isElementNode, $isRangeSelection, COMMAND_PRIORITY_LOW } from "lexical";
import { useLexicalComposer } from "lexical-vue";
import { onMounted, onUnmounted } from "vue";

import { EVENT_INSERT_HORIZONTAL_RULE } from "../const";
import { $createHorizontalRuleNode } from "../nodes/HorizontalRuleNode";

const editor = useLexicalComposer();

const handleInsertHorizontalRule = () => {
  editor.update(() => {
    const selection = $getSelection();
    if (!$isRangeSelection(selection)) {
      return;
    }

    const anchor = selection.anchor.getNode();
    const topLevelElement = anchor.getTopLevelElementOrThrow();

    const hrNode = $createHorizontalRuleNode();
    topLevelElement.insertAfter(hrNode);

    if (hrNode.getNextSibling() === null) {
      const paragraphNode = $createParagraphNode();
      hrNode.insertAfter(paragraphNode);
      paragraphNode.selectStart();
    } else {
      const nextSibling = hrNode.getNextSibling();
      if ($isElementNode(nextSibling)) {
        nextSibling.selectStart();
      }
    }
  });

  return true;
};

let unregisterListeners: () => void;

onMounted(() => {
  unregisterListeners = editor.registerCommand(
    EVENT_INSERT_HORIZONTAL_RULE,
    handleInsertHorizontalRule,
    COMMAND_PRIORITY_LOW
  );
});

onUnmounted(() => {
  unregisterListeners?.();
});
</script>

<template>
  <slot />
</template>
